import Link from 'next/link';
import styles from './checkBoxForForm.module.scss';

const CheckboxForForm = ({
  consentChecked,
  setConsentChecked,
  maxWidth = '100%',
}: {
  consentChecked: boolean;
  setConsentChecked: (checked: boolean) => void;
  maxWidth?: string;
}) => {
  return (
    <div className={styles.consentCheckbox} style={{ maxWidth }}>
      <label>
        <input
          type="checkbox"
          checked={consentChecked}
          onChange={(e) => setConsentChecked(e.target.checked)}
        />
        <span>
          By checking this box, I provide my signature and express consent to
          receive recurring automated promotional and personalized marketing
          text messages (e.g., flight updates, jet card offers) from Hera
          Enterprises, LLC at the cell number provided. Consent is not a
          condition of any purchase. Message frequency varies. Message and data
          rates may apply. You can unsubscribe at any time by replying STOP to
          any message. For help, reply HELP. View our {''}
          <Link href="/privacy-policy" className={styles.privacyPolicyLink}>
            Privacy Policy
          </Link>
          {''} and {''}
          <Link href="/terms-of-service" className={styles.privacyPolicyLink}>
            Terms of Service
          </Link>
          .
        </span>
      </label>
    </div>
  );
};

export default CheckboxForForm;
